import { type Component } from 'vue';

import AemcLimitedAccessModal from './limited-access-modal/limitedAccessModal.vue';

export default {
	AemcLimitedAccessModal
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
} as { [key: string]: Component<any, any, any, any, any> };
